module.exports = __webpack_public_path__ + "assets/img/confirm_btn.d38e23fc.png";